<form id="cashCollectedForm" #cashCollectedForm="ngForm">
  <p-dialog header="Collect Cash/Check" [(visible)]="showDialog" [modal]="true" [blockScroll]="true" (onHide)="cancel(false)" [style]="{width: '480px'}">
    @if (!isLoading) {
      <div>
        @if (cashCollected.length == 0) {
          <span class="fine-print" style="margin-bottom: 5px;">No Cash or Check Collected</span>
        }
        @for (cash of cashCollected; track cash; let i = $index) {
          <div style="margin-bottom: 5px; display: flex; align-items: center; flex-wrap: nowrap;">
            <label for="total"><span class="totalLabel">Value of Cash or Check Collected</span>&nbsp;&nbsp;</label>
            @if (workOrder) {
              <input
                pInputText
                [name]="'cashCollected' + i"
                [textMask]="{mask: currencyMask, placeholderChar: '\u2000'}"
                [ngModel]="cash.amount"
                [disabled]="!isCashCollectedEditable() || cash.invoiced"
                class="total-boxes"
                (ngModelChange)="cashCollectedChange($event, i)"
                required
                />
            }
            @if (!cash.id && isCashCollectedEditable()) {
              <p-button 
                type="button"
                severity="danger"
                (click)="removeCashCollectedEntry(i)"
                icon="pi pi-trash">
              </p-button>
            }
          </div>
        }
        <div>
          @if (isCashCollectedEditable()) {
            <p-button 
              type="button"
              severity="success" class="smallButton"
              (click)="pushNewCashCollectedEntry()"
              label="Cash or Check Collected">
            </p-button>
          }
        </div>
      </div>
    }

    <app-loading-swirly [isLoading]="isLoading"></app-loading-swirly>
    <app-loading-swirly [isLoading]="saving"></app-loading-swirly>
    <div class="footer">
      <p-button type="button" (click)="save(cashCollectedForm)" label="Save" [disabled]="saving || disableSave"></p-button>
      <p-button type="button" (click)="cancel(false)" label="Cancel" severity="info"></p-button>   
    </div>
  </p-dialog>
</form>